module.exports = __webpack_public_path__ + "static/media/working.3e94ee93.png";